import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card__head d-flex align-items-center" }
const _hoisted_2 = { class: "d-flex align-items-center ml-2" }
const _hoisted_3 = { class: "bt-icon my-auto bt-icon--m" }
const _hoisted_4 = { class: "ml-3" }
const _hoisted_5 = { class: "mt-1 mb-0" }
const _hoisted_6 = { class: "my-0 text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "card--slim" }, {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InlineSvgScoped, {
              src: 
                                require(`@/assets/images/entrancePlants/${_ctx.guestItemIcon}`)
                            ,
              "aria-label": _ctx.guestItemIcon
            }, null, 8, ["src", "aria-label"])
          ]),
          _createVNode("span", _hoisted_4, [
            _createVNode("h6", _hoisted_5, _toDisplayString(_ctx.guest.description), 1),
            _createVNode("small", _hoisted_6, _toDisplayString(_ctx.getParsedDate()), 1)
          ])
        ]),
        _createVNode(_component_Button, {
          icon: "pi pi-chevron-right",
          class: "p-button-text p-button-secondary ml-auto"
        })
      ])
    ]),
    _: 1
  }))
}